import React from "react";

export default () => (
  bla
);
